import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';
import { styles as flexboxHelpersStyles } from '../../../assets/flexbox-helpers.scss';

export const templateNoteCard = document.createElement('template');

templateNoteCard.innerHTML = `
  <style>${colorHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
    <div id="sections" class="section-container d-flex">
        <div class="title-container">
           <span class="icon icon-user"></span>
           <gz-tooltip id="tooltipUserFullName" isEllipsis="true"><gz-title fontSize="14" id="userFullname"></gz-title></gz-tooltip>
          <gz-text class="date" id="createdDate" fontsize="10"></gz-text>
        </div>
        <gz-select id="noteCardMenu" overlayPositionX="right">
          <gz-icon-button
              icon="ds-icon-more"
              fontSize="24"
              buttonType="square"
              buttonFill="quiet"
              buttonColor="secondary"></gz-icon-button>
        </gz-select>
    </div>
     <gz-text id="description" fontsize="12"></gz-text>
  </div>
`;
